// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"5dac1e91","703":"c6aaae99","722":"5522f076"}[chunkId] + ".chunk.js";
};